import React, { createContext, useCallback, useEffect, useState } from "react";
import useSWR from "swr";
import { LoadingC } from "../components";

interface LocalizationInterface {
  language?: number;
  languageKey?: string;
  isRtl?: boolean;
  currencyId?: number;
  currencySymbol?: string;
}
export const LocalizationContext = createContext<{
  sendLocalizationCallback?: (args: LocalizationInterface) => void;
  localization?: LocalizationInterface;
}>({});

const LocalizationProvider = ({ children, generals }: any) => {
  const [localization, setLocalization] = useState<LocalizationInterface>(
    JSON.parse(localStorage.getItem("localization") as any) || {}
  );
  // console.log("localization", localization);
  // useEffect(() => {
  //   let local = localStorage.getItem("localization");
  //   console.log("local", local);
  //   if (local) {
  //     setLocalization(JSON.parse(local));
  //   }
  // }, []);

  const sendLocalizationCallback = useCallback(
    (args: LocalizationInterface) => {
      let endData = { ...localization, ...args };
      console.log("endData", endData);
      setLocalization(endData);
      localStorage.setItem("localization", JSON.stringify(endData));
    },
    [localization]
  );

  return (
    <LocalizationContext.Provider
      value={{ localization, sendLocalizationCallback }}
    >
      {children}
    </LocalizationContext.Provider>
  );
};

export default LocalizationProvider;
